import { useQuery } from "@tanstack/react-query";
import { getPaymentPages } from "../services/get-payment-pages";
import { PaymentPage } from "@/pages/payment-pages/types/payment-page";
import { useRegionFilter } from "@/features/regions/hooks/use-region-filter";

interface PaginatedPaymentPages {
  paymentPages: Array<PaymentPage>;
  lastPage: number;
  nextPage: number | null;
  currentPage: number;
  total: number;
}

export default function usePaymentPages(
  page = 0,
  status?: string,
  search?: string,
) {
  const region = useRegionFilter();

  const { data, isLoading, error, isFetching, isSuccess } =
    useQuery<PaginatedPaymentPages>({
      queryKey: ["payment-pages", { page, status, region, search }],
      queryFn: () => getPaymentPages({ page, status, region, search }),
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 30,
    });

  return { data, isLoading, error, isFetching, isSuccess };
}
